<div class="row">
    <div class="col-md-12 scroll">
        <rask-list [data]="minaHandelssortiment">
            <rask-list-column [header]="texts.handelssortimentsgrupp" field="handelssortimentsgrupp" width="10%" [sortable]="true"></rask-list-column>
            <rask-list-column [header]="texts.handelssortiment" field="namn" width="25%" [sortable]="true"></rask-list-column>
            <rask-list-column [header]="texts.produkter" field="produkter" [sortable]="true"></rask-list-column>
            <rask-list-column [header]="texts.taBort" field="" width="5%">
                <ng-template let-row="row"><i (click)="removeHandelssortimenFromMinaHandelssortiment(row.id)"
                            class="rask-danger far fa-trash-alt fa-lg pointer"></i></ng-template></rask-list-column>
        </rask-list>
    </div>
</div>
